import { Table } from '@shared/Table'
import { Row, Spin, Typography } from 'antd'
import React, { useEffect, useState } from 'react'
import { orderListColumns as defaultOrderListColumns } from '../../constants/orderList.columns'
import OrderDetailsModal from '../OrderDetailsModal'
import { useAppSelector } from '@shared/hooks/useAppSelector'
import { useDispatch } from 'react-redux'
import { setXrfValue } from 'store/actions/salaryCard/setXrfValue.actions'
import { useTranslation } from 'react-i18next'
import { useFetchOrderDetailsMutation } from 'store/reducers/salaryCards/orderDetails.api'
import {
  salaryCardListApi,
  useFetchSalaryCardListQuery,
} from 'store/reducers/salaryCards/salaryCardList.api'
import { useFormContext, useWatch } from 'react-hook-form'
import { Modal } from '@shared/Modal/Modal'

function SalaryCardList() {
  const { setValue, control } = useFormContext()

  const pageSize = useWatch({ control, name: 'pageCount', defaultValue: 10 })
  const currentPage = useWatch({ control, name: 'page', defaultValue: 1 })

  const [open, setOpen] = useState(false)
  const originalArgs = useAppSelector(
    (state) => state.api.queries.fetchSalaryCardList?.originalArgs
  )
  const {
    isSuccess,
    isFetching,
    data: salaryCardList,
  } = useFetchSalaryCardListQuery(originalArgs, { skip: !originalArgs })

  const dispatch = useDispatch()
  const { t } = useTranslation()
  const orderListColumns = defaultOrderListColumns()
  const [fetchOrderDetails, { data, isLoading, isSuccess: isDSuccess }] =
    useFetchOrderDetailsMutation({
      fixedCacheKey: 'fetchOrderDetails',
    })
  const title = isLoading ? (
    t('common.loading')
  ) : (
    <>
      {`${data?.orderNo} №-${t(
        'orders.salaryCardOrder.tableTitles.tableTitles'
      )} - "`}
      <Typography.Text strong>
        {t(
          `orders.salaryCardOrder.buttonsLabels.RadioButtonGroup.${data?.status}`
        )}
      </Typography.Text>
      {'"'}
    </>
  )

  const onOpenModal = (record: any) => {
    setOpen(!open)
    dispatch(setXrfValue(record.orderNo))
    fetchOrderDetails({ orderNo: record.orderNo })
  }
  const onCloseModal = () => {
    setOpen(!open)
  }

  useEffect(() => {
    return () => {
      dispatch(salaryCardListApi.util.resetApiState())
    }
  }, [])

  return (
    <>
      <Row style={{ flexDirection: 'column' }}>
        <Table
          loading={isFetching}
          tableKey="salaryCardTable"
          sticky
          editColumns={orderListColumns}
          dataSource={isSuccess ? salaryCardList.orderList : []}
          {...(isSuccess
            ? {
                scroll: { x: 1500 },
                responsive: true,
                hideOnSinglePage: true,
                position: ['bottomCenter'],
                pagination: {
                  current: currentPage,
                  position: ['bottomCenter'],
                  responsive: true,
                  hideOnSinglePage: true,
                  defaultCurrent: 1,
                  total: salaryCardList.totalCount,
                  pageSize,
                  onChange(page) {
                    setValue('page', page)
                  },
                },
              }
            : {})}
          size="small"
          rowKey={(record) => record.orderNo}
          hideSelectAll
          selected={true}
          onClickRow={onOpenModal}
        />
        <Modal
          width={isLoading ? 500 : '100%'}
          open={open}
          centered
          title={title}
          footer={null}
          confirmLoading={true}
          onClose={onCloseModal}
        >
          {isLoading ? (
            <Spin
              size="large"
              style={{
                position: 'absolute',
                left: '50%',
                top: '50%',
                transform: 'translate(-50%, -50%)',
              }}
            />
          ) : (
            <OrderDetailsModal onCloseModal={onCloseModal} />
          )}
        </Modal>
      </Row>
    </>
  )
}

export default SalaryCardList
